import { ProductType } from "@/constants";
import { RECIPIENT_REFETCH_AFTER_SECONDS } from "@/redux/services/enhancedApi";
import {
  useGetBeneficiaryQuery,
  useGetBlockchainBeneficiaryQuery,
} from "@generated/redux/services/generated/api";

export function useGetBeneficiaryByType(
  type: ProductType,
  beneficiaryId: string
) {
  // Both queries are retained for RECIPIENT_CACHE_SECONDS; past this age a
  // remount serves the cache and refreshes trust/active state behind it.
  const currenciesQuery = useGetBeneficiaryQuery(
    { uuid: beneficiaryId },
    {
      skip: type !== "currencies" || !beneficiaryId,
      refetchOnMountOrArgChange: RECIPIENT_REFETCH_AFTER_SECONDS,
    }
  );

  const digitalAssetsQuery = useGetBlockchainBeneficiaryQuery(
    { uuid: beneficiaryId },
    {
      skip: type !== "digital-assets" || !beneficiaryId,
      refetchOnMountOrArgChange: RECIPIENT_REFETCH_AFTER_SECONDS,
    }
  );

  if (type === "currencies") {
    return currenciesQuery;
  }

  return digitalAssetsQuery;
}
